// Промежуточное ПО расширяет возможности магазина и позволяет
// вы пишете асинхронную логику, которая взаимодействует с хранилищем.
export const thunkMiddleware = () => {
    return (store) => (next) => (action) => {
        switch (typeof action) {
            case 'function':
                return action(store.dispatch, store.getState);
            case 'string':
                return next({ type: action });
            default:
                return next(action);
        }
    };
};

export default thunkMiddleware;
